/**
 * Trunnion AI - Mission Board Page
 * /missions - Kanban board for organizing workflows by mission.
 */

import { MissionBoard } from '@/components/missions/MissionBoard';

export default function MissionBoardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Mission Board</h1>
        <p className="text-sm text-trunnion-slate-400 mt-1">
          Organize workflows by mission with drag-and-drop management.
        </p>
      </div>
      <MissionBoard />
    </div>
  );
}
